var exports = {
  "kL": "x112a1f60--80a9fd--container",
  "Qs": "x112a1f60--80a9fd--content",
  "qr": "x112a1f60--80a9fd--footer",
};

module.exports = exports;
